import reducer from './dialogDetailSlips.reducer';
import * as action from './dialogDetailSlips.action';
import * as selector from './dialogDetailSlips.selector';
import * as constant from './dialogDetailSlips.constant';
import initialState from './dialogDetailSlips.initialState';
import subscriber from './dialogDetailSlips.subscriber';
import saga from './dialogDetailSlips.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  subscriber,
  saga,
  name: constant.NAME,
};
